module.exports = __webpack_public_path__ + "static/img/wuliu.b36430d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/wuliu.png
// module id = lfcV
// module chunks = 44